import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { selectHasCookieBotLoaded } from "@/store/selectors/system"
export const useCookieBot = () => {
  const router = useRouter()
  const hasLoaded = useSelector(selectHasCookieBotLoaded)
  const [isVisible, setIsVisible] = useState(false)
  useEffect(() => {
    if (hasLoaded && router.asPath) {
      const showTimer = setTimeout(() => {
        if (typeof window.Cookiebot !== 'undefined') {
          setIsVisible(!window.Cookiebot.hasResponse)
        }
      }, 100)
      return () => {
        clearTimeout(showTimer)
      }
    }
  }, [hasLoaded, router.asPath])
  return {
    isVisible,
  }
}
